import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/services/index.service';

@Component({
  selector: 'app-most-login',
  templateUrl: './most-login.component.html',
  styleUrls: ['./most-login.component.scss']
})
export class MostLoginComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router:Router,
    private global:GlobalService
  ) { }

  ngOnInit(): void {  }
  
  navigateToLoginUrl(){
    this.router.navigate(['/auth/login'] , {queryParams :{
      next : this.data
    }})
    setTimeout(() => {
      this.global.scrollTop()
    }, 200);
  }
}
